import React from 'react'
import {getCheckInTitleTextByValue} from './checkInUtility';
import {CHECKIN_TITLES} from './checkInConstants';
import {ButtonLinkStyle} from '../Inputs';
import {getCopyStatusTextByValue} from "@containers/Library/libraryUtility";

interface CheckInVolumesRowProps {
    volume: Record<string, any>;
    fillCheckedOutAccessNumber: (accessNumber: string) => void;
    fillShelfLocation: (shelfLocation: string) => void;
}

export const CheckInVolumesRow = ({volume, fillCheckedOutAccessNumber, fillShelfLocation}: CheckInVolumesRowProps) => {
    return (
        <tr id={volume.id} data-testid={volume.id}>
            <td>
                <ButtonLinkStyle
                    label={volume.barcode}
                    name={`btnAccessNumber${volume.id}`}
                    onClick={() => fillCheckedOutAccessNumber(volume.barcode)}
                />
            </td>
            <td>{getCheckInTitleTextByValue(volume.status)}</td>
            <td>{getCopyStatusTextByValue(volume.copy.status)}</td>
            <td>
                <ButtonLinkStyle
                    label={volume.shelfLocation}
                    name={`btnShelfLocation${volume.id}`}
                    onClick={() => fillShelfLocation(volume.shelfLocation)}
                />
                {`${volume.status === CHECKIN_TITLES.CheckedOut ? "*" : ""}`}
            </td>
        </tr>
    );
}

